/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import { v4 as uuidv4 } from 'uuid';
import { Button, InputLabel, RadioGroup, Radio, Table, TableBody, TableContainer, Paper, Grid, Checkbox, FormControlLabel, Box } from '@mui/material';
import { TextField, SelectField, Dialog } from '../../style-guide';
import './Personal.scss';
import PaymentDetailsNew from './PaymentDetailsNew';
import { setCookie, getCookie } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { getSession, setSelectedShipping } from '../../reducers/user-reducers/UserSlicer';
import { snackbarToggle, snackbarAutoClose } from '../../reducers/snackbarSlicer';
import { FaWindowClose } from "react-icons/fa";
import { getShippingRequest, getStorageSettings, getAdditionalCostForCalc, getShipmentCost, getBase64RecieptList, deleteReciept, getCouponValue1, isValidCoupon, getCouponList, validateHebrewText, validatePhone, listWarehouse, getExchangeRate, saveProfile, cardTextFromNumber, cardFromType, checkCvvAndNumber, cardFromNumber, validateMonth, validateYear, validateCardNumber, validateDigits, validateMyId, getCityStreetNcode, getZigZagAddresses, registerUser, ping, validateEmail, copyToClipboard1, shipping_upload, shipping_upload_again, shippingDelivaryRequestPay, shippingDelivaryRequestPayWithToken, setUserData, getETAStatus } from '../../reducers/requestHandler';
import { settingsRedbox, weightAndVal, cc_months, cc_years, shippingCoPoints } from '../../constants/global-constants';
import CloseIcon from '@mui/icons-material/Close';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import copy from '../../images/copy.png'
import upload from '../../images/upload.png'
import file from '../../images/file.png'
import del from '../../images/del.jpg'
import RedBoxBg from '../../images/box-background-img.png'
import CcCardImg from '../../images/cc-img-center.png'

import questionMark from '../../images/question-mark.png'
import checkMarkCopy from '../../images/check-mark-copy.png'
import DialogWithSideBar from '../../style-guide/Dialog/DialogWithSideBar';
import Loader from '../../style-guide/Loader';
import ActionButton from '../Common/ActionButton';
import DoneIcon from '@mui/icons-material/Done';
import { FaCheckCircle, FaCheck, FaWifi, } from "react-icons/fa";
import ClearIcon from '@mui/icons-material/Clear';
import { chWtMultiplier } from '../../constants/global-constants';
import addresses_cities from '../res.json';
import addresses_cities_csv from '../res.csv';

var tokenFlag = false;
var tempCityId = null;
var tempStreetId = null;
var tempBuildingId = null;

const screens = [{ id: 1, screen: 1, title: 'העלאת חשבונית' }, { id: 2, screen: 2, title: 'השלמת פרטי משלוח' }, { id: 3, screen: 3, title: 'תשלום' }];
const screensMulti = [{ id: 1, screen: 1, title: 'העלאת חשבוניות' }, { id: 2, screen: 2, title: 'השלמת פרטי משלוח' }, { id: 3, screen: 3, title: 'תשלום' }];
const months = [{ id: 1, name: "חודש" }];
const sleeps = [{ id: 1, name: "שנה" }];
const currencies = [{ id: 1, name: "$ דולר", symbol: "$" }, { id: 2, name: "€ אירו", symbol: "€" }, { id: 3, name: "£ פאונד", symbol: "£" }, { id: 4, name: "zł זלוטי", symbol: "zł" }, { id: 5, name: "C$ דולר קנדי", symbol: "C$" }];
const otpArr = [{ id: 1, val: "1" }, { id: 2, val: "2" }, { id: 3, val: "3" }, { id: 4, val: "4" }, { id: 5, val: "5" }, { id: 6, val: "6" }];
const personals = [{
    id: 1, val: "1", name: "Ofer Milkin", addLine1: "Nashua, NH, 03063", addLine2: ".472 Amherst St", city: "Nashua", state: "NH", zipCode: "03063", phone: "781-491-0874"
}, {
    id: 2, val: "2", name: "Ofer Milkin", addLine1: "Nashua, NH, 03063", addLine2: ".472 Amherst St", city: "Nashua", state: "NH", zipCode: "03063", phone: "781-491-0874"
}, { id: 3, val: "3", name: "Ofer Milkin", addLine1: "Nashua, NH, 03063", addLine2: ".472 Amherst St", city: "Nashua", state: "NH", zipCode: "03063", phone: "781-491-0874" }];

const data = {
    cirtificateList: [{ id: 1, name: "כן" }, { id: 2, name:"לא"}],
    selectedCurrency: currencies[0].id,
    selectedMonth: 0,//cc_months[0].id,
    selectedYear: 0,//cc_years[0].id,
    certificateId: 1,
    costOfItem: 0,
    totalCost: 0,
    invoiceOriginal: 0,
    orgTotalCost: 0,
    totalInvoice: 0,
    weight: 0,
    transportVal: 0,
    cif: 0,
    cD: 0,
    customsCharge: 0,
    insurence: 0,
    purchaseTax: 0,
    vat: 0,
    isCertificate: true,
    isInsurence: null,
    homeDelivary: true,
    mycvv: '',
    ccno: '',
    cctype: '',
    myid: '',
    cc_name: '',
    profileId: '',
    otp: '',
    nickName: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    hpAuth: '',
    isCoupon: false,
    payByToken: false,
    rememberPayment: true,
    isTnc: false,
    countryCode: '',
    addressLine_1: '',
    addressLine_2: '',
    state: '',
    city: '',
    couponText: '',
    postal: '',
    cityId: 0,
    streetId: 0,
    buildingId: 0,
    ncodeId: 0,
    addCharges: 0,
    cityNum: '',
    addName: '',
    addPhone: '',
    buildingNum: '',
    ncodeNum: '',
    streetNum: '',
}

export const SecondPayment = (props) => {
    const { isPersonal, setIsPersonal, get_shipping_list_count } = props;
    const { userInfo, selectedShipping } = useSelector(state => state.user);
    const [wareHouses, setWareHouses] = new useState([]);
    const [value, setValue] = useState(data);
    const [inValidMyId, setInValidMyId] = useState(false);
    const [inValidCard, setInValidCard] = useState(false);
    const [inValidCcName, setinValidCcName] = useState(false);
    const [activeScreen, setActiveScreen] = useState(1);
    const [paymentValidation, setPaymentValidation] = useState({
        bYear: true,
        bMonth: true,
        bCC: true,
        bCVV: true,
        bId: true,
    });
    
    const [bIsra, setBIsra] = useState(false);
    const [isFileUploaded, setIsFileUploaded] = useState(true);
    const dispatch = useDispatch();
    const [gettingUpdatedValues, setGettingUpdatedValues] = useState(false);
    
    const checkForServiceAndOnHold = (sh, callback) => {
        setGettingUpdatedValues(true);
        //dispatch(setIsShippingLoading(true));
        getShippingRequest(userInfo.session, sh.hawb, function (data) {
            data.params = JSON.parse(data.paramsNew);
            if (data.repayment) {
                callback(true)
                suc = true;
            } else {
                callback(false)
            }
            setGettingUpdatedValues(false);
        })
    }
    
    function removeEmpty(obj) {
        return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
    }

    const shipping_pay = () => {
        checkForServiceAndOnHold(selectedShipping, function (state) {
            if (state?.repayment) {
                var mul = 3.25;
                if (exchangeRate.rates) {
                    mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
                }
                if (!mul) {
                    mul = 3.25;
                }
                var curPayment = selectedShipping?.params?.curPayment;
                var totalUSD = 0;
                var totalNIS = 0;
                for (var i = 0; i < curPayment.length; i++) {
                    var amt = Number(curPayment[i]["amt"]);
                    if (Number(curPayment[i]["cur"]) == 1) {
                        var amtNIS = amt * mul;
                        totalUSD += Number(Number(amt).toFixed(2));
                        totalNIS += Number(Number(amtNIS).toFixed(2));
                    } else {
                        var amtUSD = amt / mul; 
                        totalUSD += Number(Number(amtUSD).toFixed(2));
                        totalNIS += Number(Number(amt).toFixed(2));
                    }
                }
                totalNIS = Number(Number(totalNIS).toFixed(2));
                totalUSD = Number(Number(totalUSD).toFixed(2));

                var data1 = {
                    "shippingReqId": selectedShipping?.id,
                    "rememberPayment": value.rememberPayment,
                    "currency": value.selectedCurrency,
                    "curPayment": curPayment,
                    "totalUSD": totalUSD,
                    "totalNIS": totalNIS,
                    "amount_nis": totalNIS,
                    "myid": value.myid,
                    "mycvv": value.mycvv,
                    "cc_name": value.cc_name,
                    "cctype": value.cctype,
                    "ccno": value.ccno,
                    "sessionId": userInfo.session,
                    "expdate": "" + cc_months.find(u => u.id === value.selectedMonth)?.name + "" + cc_years.find(u => u.id === value.selectedYear)?.name,
                    "type": "TRANZILA",
                    "cred_type": "1",
                    "opcode": "newPayByCard",
                    "majorCategory": categories.find(u => u.id === value.category)?.name || "-",
                    "minorCategory": subcategories.find(u => u.id === value.subcategory)?.name || "-",
                };
                
                
                setIsFileUploaded(false)
                shippingDelivaryRequestPay(userInfo.session, data1, function (response) {
                    setIsFileUploaded(true)
                    if (response.misc.CODE === 1) {
                        dispatch(snackbarToggle({ type: 'success', message: `התשלום בוצע בהצלחה` }));
                        setIsPersonal(false)
                        get_shipping_list_count();
                        //setActiveScreen(8);
                    } else {
                        if (response.message === "The payment is invalid please restart payment.") {
                            //setIsPersonal(false);
                            window.location.reload();
                        } else
                            dispatch(snackbarToggle({ type: 'error', message: response.message }));
                    }
                    //setActiveScreen(6)
                })
            }
        });
        

    }
    const shipping_pay_token = (event, newValue) => {
        checkForServiceAndOnHold(selectedShipping, function (state) {
            if (state) {
                var mul = 3.25;
                if (exchangeRate.rates) {
                    mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
                }
                if (!mul) {
                    mul = 3.25;
                }
                var curPayment = selectedShipping?.params?.curPayment;
                var totalUSD = 0;
                var totalNIS = 0;
                for (var i = 0; i < curPayment.length; i++) {
                    var amt = Number(curPayment[i]["amt"]);
                    if (Number(curPayment[i]["cur"]) == 1) {
                        var amtNIS = amt * mul;
                        totalUSD += Number(Number(amt).toFixed(2));
                        totalNIS += Number(Number(amtNIS).toFixed(2));
                    } else {
                        var amtUSD = amt / mul;
                        totalUSD += Number(Number(amtUSD).toFixed(2));
                        totalNIS += Number(Number(amt).toFixed(2));
                    }
                }
                totalNIS = Number(Number(totalNIS).toFixed(2));
                totalUSD = Number(Number(totalUSD).toFixed(2));
                
                var data1 = {
                    "opcode": "newPayByToken",
                    "curPayment": curPayment,
                    "sessionId": userInfo.session,
                    "currency": value.selectedCurrency,
                    "totalUSD": totalUSD,
                    "totalNIS": totalNIS,
                    "amount_nis": totalNIS,
                    "shippingReqId": selectedShipping?.id,
                    "cred_type": "1",
                    "type": "TRANZILA",
                    "majorCategory": categories.find(u => u.id === value.category)?.name || "-",
                    "minorCategory": subcategories.find(u => u.id === value.subcategory)?.name || "-",
                };
                setIsFileUploaded(false)

                data1 = removeEmpty(data1);

                data1.len = value.len;
                data1.wid = value.wid;
                data1.hei = value.hei;
                data1.wgt = value.wgt;
                data1.constWt = value.constWt;
                shippingDelivaryRequestPayWithToken(userInfo.session, data1, function (response) {
                    setIsFileUploaded(true)
                    if (response.misc.CODE === 1) {
                        dispatch(snackbarToggle({ type: 'success', message: `התשלום בוצע בהצלחה` }));
                        setIsPersonal(false)
                        get_shipping_list_count();
                        //setActiveScreen(8);
                    } else {
                        if (response.message === "The payment is invalid please restart payment.") {
                            setIsPersonal(false);
                            window.location.reload();
                        } else
                            dispatch(snackbarToggle({ type: 'error', message: response.message }));
                    }
                    //setActiveScreen(6)
                })
            }
        });
    }
    const [cities, setCities] = useState([]);
    const [streets, setStreets] = useState([]);
    const [addCities, setAddCities] = useState([]);
    const [addStreets, setAddStreets] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [houseNumIsNotProper, setHouseNumIsNotProper] = useState(false);
    const [zipNumIsNotProper, setZipNumIsNotProper] = useState(false);
    const [addressIsNotProper, setAddressIsNotProper] = useState(false);
    const [ncodes, setNcodes] = useState([]);
    const handleWarHWts = (w, len) => {

        var t = [];
        try {
            var tV = w?.params?.wtNval;
            for (var i = 0; i < len; i++) {
                if (tV[i][0] && tV[i][1]) {
                    t.push({
                        wt: Number(tV[i][0]),
                        val: Number(tV[i][1]),
                    })
                }
            }
        } catch (e) {
            console.log(e)
        }

        // setWtAndVals(t)
        return t;
    }

    const [change, setChange] = useState(false);
    const [uploadedOrgFiles, setUploadedOrgFiles] = useState([]);
    const [uploadedOrgFilesBase64, setUploadedOrgFilesBase64] = useState([]);
    const getBase64Reciepts = () => {

        getBase64RecieptList({ id: selectedShipping.id, sessionId: userInfo.session }, function (response) {
            if (response.misc.CODE === 1) {
                setUploadedOrgFilesBase64(response.data)
                if (response?.data?.length) {
                    setUploadedPdfBse64Id(response.data[0].id)
                    setUploadedPdfBse64(response.data[0])
                }
            }
        })
    }
    const [shipmentCost1, setShipmentCost1] = useState({ id: null });
    const [storageSettings, setStorageSettings] = useState({});

    function cityExists(cts, name) {
        for (var i = 0; i < cts.length; i++) {
            if (cts[i].cityName === name) {
                return true;
            }
        }
        return false;
    }
    function streetExists(cts, name) {
        for (var i = 0; i < cts.length; i++) {
            if (cts[i].streetName === name) {
                return true;
            }
        }
        return false;
    }
    function houseExists(cts, name) {
        for (var i = 0; i < cts.length; i++) {
            if (cts[i].houseList.contains(name)) {
                return true;
            }
        }
        return false;
    }
    const [additionalCostForCalc, setAdditionalCostForCalc] = useState(null);
    const [exchangeRate, setExchangeRate] = new useState({});
    useEffect(() => {
        getAdditionalCostForCalc(function (data) {
            if (userInfo.user.isComm)
                data.data.cost75 = 0;
            setAdditionalCostForCalc(data.data);
        });
        getStorageSettings(function (data) {
            setStorageSettings(data);
        });
        getShipmentCost(function (resp) {
            if (resp?.data)
                setShipmentCost1(resp?.data)
        });
        
        listWarehouse(function (data) {
            var ws = JSON.parse(JSON.stringify(data.data))
            var t = [];
            ws?.map((w, index) => {
                if (w.params?.active || w.name === 'טורקיה' || w.name === "Test") {
                    try {
                        w.wtNval = handleWarHWts(w, w.params?.wtNval.length);
                    } catch (e) {
                        console.log(e)
                    }
                    t.push(w);
                }
            })
            setWareHouses(t);

        });
        getExchangeRate(function (res) {
            setExchangeRate(res);
        });

        setValue(prev => ({ ...prev, payByToken: userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate")) }))
        if (tokenFlag)
            setValue(prev => ({ ...prev, tokenFlag }))
        tokenFlag = false;
    }, [dispatch, selectedShipping, setExchangeRate, setWareHouses, userInfo]);
    

    const categories = settingsRedbox.map((setting, index) => ({
        id: index + 1,
        name: setting.name
    }));
    
    const [subcategories, setSubcategories] = useState([]);
    const [subcategories3, setSubcategories3] = useState([]);
    const [subcategories4, setSubcategories4] = useState([]);
    const [subcategories5, setSubcategories5] = useState([]);
    const [subcategories6, setSubcategories6] = useState([]);
    const [subcategories7, setSubcategories7] = useState([]);

    
    const progressSteps = (currentScreen = null) => (
        <>
            {/*<Grid container className="screen-progress-steps">
                <Box className={`progress-step current done'}`}>
                    <Box className="step-title">
                        {'תשלום'}
                    </Box>
                </Box>
            </Grid>*/}

        </>
    );
    
    const getConvertedCostByCurToUsd = (cur, amount) => {

        if (cur == 1) {
            setValue(prev => ({ ...prev, curMul: 1 }));
        }
        if (cur == 2) {
            var eurMul = 1.03;
            if (exchangeRate.rates) {
                eurMul = exchangeRate?.rates?.USD
            }
            amount = amount * eurMul;
            setValue(prev => ({ ...prev, curMul: eurMul }));
            return amount
        }
        if (cur == 3) {
            var poundMul = 1.28;
            if (exchangeRate.rates) {
                poundMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.GBP
            }
            setValue(prev => ({ ...prev, curMul: poundMul }));
            amount = amount * poundMul;
            return amount
        }
        if (cur == 4) {
            var polMul = 0.25;  
            if (exchangeRate.rates) {
                polMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.PLN
            }
            setValue(prev => ({ ...prev, curMul: polMul }));
            amount = amount * polMul;
            return amount
        }
        if (cur == 5) {
            var cadMul = 0.73;
            if (exchangeRate.rates) {
                cadMul = exchangeRate?.rates?.USD / exchangeRate?.rates?.CAD
            }
            setValue(prev => ({ ...prev, curMul: cadMul }));
            amount = amount * cadMul;
            return amount
        }
        return Number(amount)
    }
    function insert(main_string, ins_string, pos) {
        if (!main_string)
            return "";
        if (typeof (pos) == "undefined") {
            pos = 0;
        }
        if (typeof (ins_string) == "undefined") {
            ins_string = '';
        }
        return main_string?.slice(0, pos) + ins_string + main_string?.slice(pos);
    }
    const getTotalNIS = (curPayment) => {
        var mul = 3.25;
        if (exchangeRate.rates) {
            mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
        }
        if (!mul) {
            mul = 3.25;
        }
        var totalNIS = 0;
        for (var i = 0; i < curPayment.length; i++) {
            var amt = Number(curPayment[i]["amt"]);
            if (Number(curPayment[i]["cur"]) == 1) {
                var amtNIS = amt * mul;
                totalNIS += Number(Number(amtNIS).toFixed(2));
            } else {
                totalNIS += Number(Number(amt).toFixed(2));
            }
        }
        return Number(Number(totalNIS).toFixed(2));
    }
    const getTotalUSD = (curPayment) => {
        var mul = 3.25;
        if (exchangeRate.rates) {
            mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
        }
        if (!mul) {
            mul = 3.25;
        }
        var totalUSD = 0;
        for (var i = 0; i < curPayment.length; i++) {
            var amt = Number(curPayment[i]["amt"]);
            if (Number(curPayment[i]["cur"]) == 1) {
                totalUSD += Number(Number(amt).toFixed(2));
            } else {
                var amtUSD = amt / mul;
                totalUSD += Number(Number(amtUSD).toFixed(2));
            }
        }
        return Number(Number(totalUSD).toFixed(2));
    }
        
    return (

        <DialogWithSideBar
            open={isPersonal}

            onClose={() => {
                //if (activeScreen != 8) {
                //    onHandleOpenModal()
                //} else {
                    setIsPersonal(false)
                //}
            }}
            isBackButton={activeScreen == 4 || activeScreen == 5 || activeScreen == 6}
            onClickBack={() => setActiveScreen(activeScreen - 1)}
        >
            <Box className="reg_popup_data">
                {progressSteps(3)}


                {isFileUploaded && <Grid item container>
                    <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '24px' }} justifyContent="center">
                        <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: "20px" }}>
                            תשלום
                        </Grid>
                        <Grid></Grid>
                    </Grid>
                    <Grid container item lg={12} className="" justifyContent="flex-start" alignContent="flex-start" sx={{ direction: 'rtl' }}>

                        {(userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate"))) && <Box style={{ marginRight: "10px", height: '51px', padding: '18px 32px 20px', border: 'solid 1px #f0f0f2', backgroundColor: '#f6f6f6' }} className={value.payByToken ? 'Business selected_acc' : 'Business'} onClick={() => { setValue(prev => ({ ...prev, payByToken: true })) }}>
                            פרטי אשראי
                        </Box>
                        }
                        <Box style={{ height: '51px', padding: '18px 32px 20px', border: 'solid 1px #f0f0f2', backgroundColor: '#f6f6f6' }} className={!value.payByToken ? 'Business selected_acc' : 'Business'} onClick={() => { setValue(prev => ({ ...prev, payByToken: false })) }}>
                            {!(userInfo?.user?.setting?.TranzilaTK && (userInfo?.user?.setting?.expdate || (userInfo?.user?.setting?.expdateTK && userInfo?.user?.setting?.expdateTK !== "expdate"))) ? 'תשלום באשראי' : "כרטיס אשראי"}
                        </Box>
                    </Grid>

                    {value.payByToken && <Grid container justifyContent="space-between" sx={{ mt: 2 }}>

                        <Grid container justifyContent="space-between" flexWrap={'nowrap'} sx={{ mt: 0 }}>
                            <img alt="" src={cardFromType(userInfo?.user?.setting?.TranzilaTK)} className="flag_img" style={{ paddingRight: '5px', height: "56px" }} />
                            <TextField
                                className='text-field-disabled'
                                required
                                value={`visa: ${insert(userInfo?.user?.setting?.ccno, "-", userInfo?.user?.setting?.ccno?.length - 4)}`}
                                onChange={() => { }}
                                label="מספר כרטיס אשראי"
                                readOnly={true}
                            />

                        </Grid>
                        {!userInfo.user.setting?.profileId && <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                            <TextField
                                className='text-field'
                                required
                                value={value.profileId}
                                onChange={event => setValue(prev => ({ ...prev, profileId: event.target.value }))}
                                label='תעודת זהות של בעל החשבון'
                            />
                        </Grid>
                        }
                    </Grid>}
                    {!value.payByToken && <><Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                        <TextField
                            className='text-field'
                            required
                            value={value.cc_name}
                            onChange={event => {
                                setValue(prev => ({ ...prev, cc_name: event.target.value }));
                                setinValidCcName(true)
                            }}
                            onBlur={() => { setinValidCcName(true) }}
                            label='שם בעל הכרטיס'
                        />
                        {inValidCcName && !value.cc_name && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                            Invalid Name
                        </Box>
                        }
                        <TextField
                            className='text-field'
                            required
                            value={value.myid}
                            onChange={event => {
                                setValue(prev => ({ ...prev, myid: event.target.value }));
                                if (!validateMyId(event.target.value)) {
                                    setPaymentValidation(prev => ({ ...prev, bId: true }));
                                    // if (value.myid)
                                    // dispatch(snackbarToggle({ type: 'error', message: "Invalid Id." }));

                                    return;
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bId: false }));
                                }
                            }}
                            onBlur={event => {
                                if (!validateMyId(value.myid)) {
                                    setPaymentValidation(prev => ({ ...prev, bId: true }));
                                    // if (value.myid)
                                    // dispatch(snackbarToggle({ type: 'error', message: "Invalid Id." }));

                                    return;
                                } else {
                                    setPaymentValidation(prev => ({ ...prev, bId: false }));
                                }
                            }}
                            label="תעודת זהות של בעל הכרטיס"
                            type="number"
                        />
                        {!validateMyId(value.myid) && value.myid && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                            Invalid ID
                        </Box>
                        }
                        <Grid container justifyContent="space-between" flexWrap={'nowrap'} sx={{ mt: 0 }}>

                            <img alt="" src={cardFromNumber(value.ccno)} className="flag_img" style={{ paddingRight: '5px', height: "56px" }} />
                            <TextField
                                className='text-field'
                                required
                                value={value.ccno}
                                onChange={event => {
                                    setValue(prev => ({ ...prev, ccno: event.target.value }));
                                    setInValidCard(false);
                                    setValue(prev => ({ ...prev, cctype: cardTextFromNumber(event.target.value) }))
                                    validateCardNumber(event.target.value, function (bSucc, bIsra) {
                                        if (!bSucc) {
                                            if (!bIsra)
                                                setPaymentValidation(prev => ({ ...prev, bCC: true }));
                                            else
                                                setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                            if (value.ccno) {
                                                //dispatch(snackbarToggle({ type: 'error', message: "Invalid card." }));
                                                if (!bIsra)
                                                    setInValidCard(true)
                                                return;
                                            }
                                        } else {
                                            setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                        }
                                        setBIsra(bIsra);
                                    })
                                }}
                                label="מספר כרטיס אשראי"
                                type="number"
                                onBlur={event => {

                                    setValue(prev => ({ ...prev, cctype: cardTextFromNumber(value.ccno) }))
                                    validateCardNumber(value.ccno, function (bSucc, bIsra) {
                                        if (!bSucc) {
                                            if (!bIsra)
                                                setPaymentValidation(prev => ({ ...prev, bCC: true }));
                                            else
                                                setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                            if (value.ccno) {
                                                //dispatch(snackbarToggle({ type: 'error', message: "Invalid card." }));
                                                if (!bIsra)
                                                    setInValidCard(true)
                                                return;
                                            }
                                        } else {
                                            setPaymentValidation(prev => ({ ...prev, bCC: false }));
                                        }
                                        setBIsra(bIsra);
                                    })
                                }}
                            />

                        </Grid>
                        {inValidCard && value.ccno && <Box className='col-md-12' style={{ direction: "rtl", color: "red", top: "-20px" }}>
                            Invalid card
                        </Box>
                        }
                    </Grid>

                        <Grid container justifyContent="space-between" flexWrap={'nowrap'} sx={{ mt: 2 }}>

                            <TextField
                                className='text-field'
                                required
                                value={value.mycvv}
                                onChange={event => {
                                    setValue(prev => ({ ...prev, mycvv: event.target.value }));
                                    if (event.target.value.length > 5) {
                                        setPaymentValidation(prev => ({ ...prev, bCVV: true }));
                                        return;
                                    }
                                    if (!checkCvvAndNumber(event.target.value, value.ccno)) {
                                        setPaymentValidation(prev => ({ ...prev, bCVV: true }));
                                        //dispatch(snackbarToggle({ type: 'error', message: "Invalid CVV." }));
                                        return;
                                    } else {
                                        setPaymentValidation(prev => ({ ...prev, bCVV: false }));
                                    }
                                }}
                                label="CVV"
                                parentClassName={'prefix-select width-30 no-input-pad'}
                                type="number"
                                onBlur={event => {
                                    if (!checkCvvAndNumber(value.mycvv, value.ccno)) {
                                        setPaymentValidation(prev => ({ ...prev, bCVV: true }));
                                        //dispatch(snackbarToggle({ type: 'error', message: "Invalid CVV." }));
                                        return;
                                    } else {
                                        setPaymentValidation(prev => ({ ...prev, bCVV: false }));
                                    }
                                }}
                            />

                            <Box sx={{ direction: "rtl" }}>
                                <InputLabel sx={{ mr: 1.5 }}>
                                    שנה
                                </InputLabel>
                                <SelectField
                                    className='text-field padding_17'
                                    required
                                    value={value.selectedYear}
                                    lg={12}
                                    isNumeric={true}
                                    onChange={event => {
                                        var y = cc_years.find(u => u.id === event.target.value)?.name || "22";
                                        var m = cc_months.find(u => u.id === value.selectedMonth)?.name || false;

                                        if (!validateYear(y)) {
                                            setPaymentValidation(prev => ({ ...prev, bYear: true }));
                                            // dispatch(snackbarToggle({ type: 'error', message: "Invalid Year." }));
                                            return;
                                        } else {
                                            setPaymentValidation(prev => ({ ...prev, bYear: false }));
                                        }
                                        setValue(prev => ({ ...prev, selectedYear: event.target.value }))
                                        if (m) {
                                            if (!validateMonth(y, m)) {
                                                setPaymentValidation(prev => ({ ...prev, bMonth: true }));
                                                // dispatch(snackbarToggle({ type: 'error', message: "Invalid Month." }));
                                                return;
                                            } else {
                                                setPaymentValidation(prev => ({ ...prev, bMonth: false }));
                                            }
                                        } else {
                                            setPaymentValidation(prev => ({ ...prev, bMonth: true }));
                                        }

                                    }}
                                    sx1={{ padding: "17px" }}
                                    sx={{ mt: -3.5 }}
                                    options={cc_years}
                                    islabelAnimate={false}
                                    label="שנה"
                                    parentClassName={'prefix-select width-100'}
                                />
                            </Box>
                            <Box sx={{ direction: "rtl" }}>
                                <InputLabel sx={{ mr: 1.5 }}>
                                    חודש
                                </InputLabel>
                                <SelectField
                                    className='text-field padding_17'
                                    required
                                    value={value.selectedMonth}
                                    lg={3}
                                    sx1={{ padding: "17px" }}
                                    sx={{ mt: -3.5 }}
                                    isNumeric={true}
                                    onChange={event => {

                                        setValue(prev => ({ ...prev, selectedMonth: event.target.value }))
                                        var y = cc_years.find(u => u.id === value.selectedYear)?.name || "22";
                                        var m = cc_months.find(u => u.id === event.target.value)?.name || "01";
                                        if (!validateMonth(y, m)) {
                                            setPaymentValidation(prev => ({ ...prev, bMonth: true }));
                                            // dispatch(snackbarToggle({ type: 'error', message: "Invalid Month." }));
                                            return;
                                        } else {
                                            setPaymentValidation(prev => ({ ...prev, bMonth: false }));
                                        }
                                    }}
                                    options={cc_months}
                                    islabelAnimate={false}
                                    label="חודש"
                                    parentClassName={'prefix-select width-100'}
                                />
                            </Box>
                        </Grid>
                        {!userInfo.user.setting?.profileId && <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                            <TextField
                                className='text-field'
                                required
                                value={value.profileId}
                                onChange={event => setValue(prev => ({ ...prev, profileId: event.target.value }))}
                                label='תעודת זהות של בעל החשבון'
                            />
                        </Grid>
                        }
                        {(!checkCvvAndNumber(value.mycvv, value.ccno) || value.mycvv.length > 5) ? <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%" }}>
                            Invalid CVV
                        </Box> : <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%" }}>

                        </Box>
                        }
                        {paymentValidation.bYear ? <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%", marginLeft: "12%" }}>
                            Invalid Year
                        </Box> : <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%", marginLeft: "12%" }}>

                        </Box>
                        }
                        {paymentValidation.bMonth ? <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "22%", marginLeft: "5%" }}>
                            Invalid Month
                        </Box> : <Box className='col-md-12' style={{ direction: "ltr", color: "red", top: "-20px", width: "30%" }}>

                        </Box>
                        }
                        <Grid container justifyContent="space-between" flexDirection="row-reverse" flexWrap={'nowrap'} sx={{ mt: 2 }}>
                            <Box container className='checkboxs'>
                                <FormControlLabel dir='rtl' key={uuidv4()} control={< Checkbox checked={value?.rememberPayment} onChange={event => setValue(prev => ({ ...prev, rememberPayment: event.target.checked }))} />} label={"שמור פרטי כרטיס"} />
                            </Box>
                        </Grid>
                    </>}
                    {<Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh', direction: 'rtl' }}>
                        <PaymentDetailsNew info={selectedShipping?.params?.curPayment} totalNIS={getTotalNIS(selectedShipping?.params?.curPayment)} totalUSD={getTotalUSD(selectedShipping?.params?.curPayment)} showItemsTitle={true} />
                    </Grid>}
                </Grid>}
                {!isFileUploaded && <Loader />}
                <Box className='form-action' style={{ marginTop: '40px', marginBottom: "15vh" }}>
                    {/*{paymentValidation.bMonth.toString()} {paymentValidation.bYear.toString()} {paymentValidation.bCC.toString()} {paymentValidation.bCVV.toString()} {paymentValidation.bId.toString()}*/}
                    {value.payByToken && <ActionButton disabled={gettingUpdatedValues || !userInfo.user?.setting?.TranzilaTK || !isFileUploaded} className={'submit-action'} textLabel={'תשלום'} onClick={() => {
                        shipping_pay_token();
                    }} />
                    }
                    {/*{paymentValidation.bMonth.toString()} {paymentValidation.bYear.toString()} {paymentValidation.bCC.toString()} {paymentValidation.bCVV.toString()} {paymentValidation.bId.toString()}*/}
                    {!value.payByToken && <ActionButton disabled={gettingUpdatedValues || !value.cc_name || paymentValidation.bMonth || paymentValidation.bYear || paymentValidation.bCC || paymentValidation.bCVV || paymentValidation.bId || !isFileUploaded} className={'submit-action'} textLabel={'תשלום'} onClick={() => {
                        shipping_pay();
                    }} />}
                </Box>
                <Grid style={{ height: "60vh" }}></Grid>
            </Box>
        </DialogWithSideBar>
    );
}

export default SecondPayment;